import React from 'react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import { Switch } from 'react-router-dom'
import PrivateRoute from '~/components/PrivateRoute'
import { Header } from '~/layout'
// import DataMap from '~/components/DataMap'
// import Controls from '~/components/Controls'
// import DataStationSearch from '~/components/DataStationSearch'
// import DataDateSearch from '~/components/DataDateSearch'
// import Scale from '~/components/Scale'
import Monitoring from '~/modules/Monitoring'
import Forecasting from '~/modules/Forecasting'
import Scenario from '~/modules/Scenario'
import Optimization from '~/modules/Optimization'

import {
  AppLayout
} from '~/components/styles'

const App = ({ view: { mode } }) => (
  <AppLayout>
    <Header />
    <Switch>
      <PrivateRoute exact path='/monitoring' component={Monitoring}/>
      <PrivateRoute exact path='/forecasting' component={Forecasting}/>
      <PrivateRoute exact path='/scenario' component={Scenario}/>
      <PrivateRoute exact path='/optimization' component={Optimization}/>
    </Switch>
  </AppLayout>
)
export default compose(
  inject('view'),
  observer
)(App)



// WEBPACK FOOTER //
// ./src/App.js